import { render, staticRenderFns } from "./digitaltransformation.vue?vue&type=template&id=667646a3&"
import script from "./digitaltransformation.vue?vue&type=script&lang=js&"
export * from "./digitaltransformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports